/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { map, filter } from "lodash";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Divider, Grid, Icon, IconButton } from "@mui/material";
import SwitchR from "react-switch";
import InformacionGeneral from "./forms/informacionGeneral";
import InformacionGeneralMenor from "./forms/informacionMenor";
import AntecedentesHeredoFamiliares from "./forms/antecedentesHeredoFamiliares";
import AntecedentesPrenatales from "./forms/antecedentesPrenatales";
import AntecedentesPerinatales from "./forms/antecedentesPerinatales";
import AntecedentesPatologicos from "./forms/antecedentesPersonlesNoPatologicos";
import EvaluacionAuditiva from "./forms/evalucionAuditivaLinguistica";
import DesarrolloMotor from "./forms/desarrolloMotor";
import DatosAdicionales1 from "./forms/datosAdicionales1";
import { find } from "lodash";
import { styled } from "@mui/material/styles";
import Check from "@mui/icons-material/Check";
import logoESF from "assets/images/LogoESF.png";
import logoGMF from "assets/images/LogoGMF3.png";
import InformacionAdicional2 from "./forms/informacionAdicional2";
import DocumentacionAdministrativa from "./forms/documentacionAdministrativa";
import DocumentacionClinica from "./forms/documentacionClinica";
import toast from "react-hot-toast";
import ModalContent from "../../components/ModalContent";

import { RegistrarIntentoSolicitud, IsValidEmail } from "store/solicitudes/solicitudesActions";
import { setIsloadingCreacion, setIsloadingExito } from "store/solicitudes/solicitudesSlice";
import AvisoPrivacidad from "./avisoPrivacidad";
import ModalExito from "components/ModalExito";

export default function VerticalLinearStepper({ CrearSolicitud }) {
  const { messageError, isLoadingCracion, isLoadingExito,procesoExitoso } = useSelector(
    (state) => state.solicitud
  );
  const [checkavisoprivacidad, setcheckavisoprivacidad] = useState(false);
  const [checkacuerdo, setcheckacuerdo] = useState(false);
  const [modalAvisoPrivacidad, setModalAvisoPrivacidad] = useState(false);
  const RefTerminos = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  const [dataInformacionGeneral, setdataInformacionGeneral] = useState(null);
  const [dataInformacionGeneralMenor, setdataInformacionGeneralMenor] = useState(null);
  const [dataAntecedentesHeredofamiliares, setdataAntecedentesHeredofamiliares] = useState(null);
  const [dataAntecedentesPrenatales, setdataAntecedentesPrenatales] = useState(null);
  const [dataAntecedentesPrenatalesTORCH, setdataAntecedentesPrenatalesTORCH] = useState(null);
  const [dataAntecedentesPerinatales, setdataAntecedentesPerinatales] = useState(null);
  const [dataAntecedentesPatologicos, setdataAntecedentesPatologicos] = useState(null);
  const [dataEvaluacionAuditivLin, setdataEvaluacionAuditivLin] = useState(null);
  const [dataDesarrolloMotor, setdataDesarrolloMotor] = useState(null);
  const [dataDatosAdicionales1, setdataDatosAdicionales1] = useState(null);
  const [dataDocumentacionAdministrativa, setdataDocumentacionAdministrativa] = useState([]);
  const [dataDocumentacionClinica, setdataDocumentacionClinica] = useState([]);
  const [dataInformacionAdicional2, setdataInformacionAdicional2] = useState(null);

  const dispatch = useDispatch();
  const steps = [
    {
      label: "Informacion general",
      component: (
        <InformacionGeneral
          Back={() => handleBack()}
          Next={(data) => {
            handleNext();
            setdataInformacionGeneral(data);
          }}
          IsValidEmail={IsValidEmail}
          props={dataInformacionGeneral ? dataInformacionGeneral : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "INFORMACIÓN GENERAL DEL MENOR",
      component: (
        <InformacionGeneralMenor
          Back={(data) => {
            handleBack();
            setdataInformacionGeneralMenor(data);
          }}
          Next={(data) => {
            handleNext();
            setdataInformacionGeneralMenor(data);
          }}
          IntentoSolicitud={(info) => {
            RegistrarIntentoSolicitud({
              ...dataInformacionGeneral,
              ...info,
            });
          }}
          props={dataInformacionGeneralMenor ? dataInformacionGeneralMenor : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "ANTECEDENTES HEREDOFAMILIARES",
      component: (
        <AntecedentesHeredoFamiliares
          Back={(data) => {
            setdataAntecedentesHeredofamiliares(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataAntecedentesHeredofamiliares(data);
          }}
          props={dataAntecedentesHeredofamiliares ? dataAntecedentesHeredofamiliares : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "ANTECEDENTES PRENATALES",
      component: (
        <AntecedentesPrenatales
          Back={(data) => {
            setdataAntecedentesPrenatales(data);
            handleBack();
          }}
          Next={(data, data2) => {
            handleNext();
            setdataAntecedentesPrenatales(data);
            setdataAntecedentesPrenatalesTORCH(data2);
          }}
          props={dataAntecedentesPrenatales ? dataAntecedentesPrenatales : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "ANTECEDENTES PERINATALES",
      component: (
        <AntecedentesPerinatales
          Back={(data) => {
            setdataAntecedentesPerinatales(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataAntecedentesPerinatales(data);
          }}
          props={dataAntecedentesPerinatales ? dataAntecedentesPerinatales : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "ANTECEDENTES PERSONALES NO PATOLÓGICOS DEL MENOR",
      component: (
        <AntecedentesPatologicos
          Back={(data) => {
            setdataAntecedentesPatologicos(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataAntecedentesPatologicos(data);
          }}
          props={dataAntecedentesPatologicos ? dataAntecedentesPatologicos : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "EVALUACIÓN AUDITIVA Y LINGÜÍSTICA",
      component: (
        <EvaluacionAuditiva
          Back={(data) => {
            setdataEvaluacionAuditivLin(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataEvaluacionAuditivLin(data);
          }}
          props={dataEvaluacionAuditivLin ? dataEvaluacionAuditivLin : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "DESARROLLO MOTOR",
      component: (
        <DesarrolloMotor
          Back={(data) => {
            setdataDesarrolloMotor(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataDesarrolloMotor(data);
          }}
          props={dataDesarrolloMotor ? dataDesarrolloMotor : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "INFORMACIÓN ADICIONAL",
      component: (
        <DatosAdicionales1
          Back={(data) => {
            setdataDatosAdicionales1(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataDatosAdicionales1(data);
          }}
          props={dataDatosAdicionales1 ? dataDatosAdicionales1 : {}}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "DOCUMENTACIÓN ADMINISTRATIVA",
      component: (
        <DocumentacionAdministrativa
          Back={(data) => {
            setdataDocumentacionAdministrativa(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataDocumentacionAdministrativa(data);
          }}
          props={dataDocumentacionAdministrativa ? dataDocumentacionAdministrativa : []}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "DOCUMENTACIÓN CLÍNICA",
      component: (
        <DocumentacionClinica
          Back={(data) => {
            setdataDocumentacionClinica(data);
            handleBack();
          }}
          Next={(data) => {
            handleNext();
            setdataDocumentacionClinica(data);
          }}
          props={dataDocumentacionClinica ? dataDocumentacionClinica : []}
        />
      ),
      ref: useRef(null),
    },
    {
      label: "INFORMACIÓN ADICIONAL",
      component: (
        <InformacionAdicional2
          Back={(data) => {
            setdataInformacionAdicional2(data);
            handleBack();
          }}
          Next={(data) => {
            // handleNext();
            setdataInformacionAdicional2(data);
            //Mandar a crear la solicitud
            if (checkavisoprivacidad && checkacuerdo) {
              CrearSolicitud({
                data: {
                  ...dataInformacionGeneral,
                  ...dataInformacionGeneralMenor,
                  ...dataAntecedentesHeredofamiliares,
                  ...dataAntecedentesPrenatales,
                  ...dataAntecedentesPerinatales,
                  ...dataAntecedentesPatologicos,
                  ...dataEvaluacionAuditivLin,
                  ...dataDesarrolloMotor,
                  ...dataDatosAdicionales1,
                  ...data,
                },
                files: {
                  docAdministrativa: [...dataDocumentacionAdministrativa],
                  docClinica: [dataAntecedentesPrenatalesTORCH, ...dataDocumentacionClinica],
                },
              });
            } else {
              toast.error(
                "Aceptar los terminos y aviso de privacidad para continuar con su registro"
              );
            }
          }}
          props={dataInformacionAdicional2 ? dataInformacionAdicional2 : {}}
        />
      ),
      ref: useRef(null),
    },
  ];
  const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    color: "#5873B8",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#F58020",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "green",
      zIndex: 1,
      fontSize: "20 !important",
    },
    "& .QontoStepIcon-circle": {
      width: "1rem",
      height: "1rem",
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  }));

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  useEffect(() => {
    setTimeout(() => {
      if (activeStep === 0 && RefTerminos.current) {
        RefTerminos.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        const itemActive = steps[activeStep];
        itemActive.ref.current?.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000);
  }, [activeStep, RefTerminos]);

  const Errores = filter(messageError, (item) => {
    return item.type === "error";
  });

  return (
    <Box>
      <Grid container spacing={2} marginTop="5px" alignItems="center">
        <Grid item xs={12} md={6} lg={6}>
          <MDBox
            display="flex"
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
            alignItems="center"
            justifyContent="left"
            marginTop="10px"
          >
            {/* Imagen izquierda */}
            <img src={logoESF} style={{ height: "3rem" }}></img>
            {/* Barra vertical (horizontal en pantallas pequeñas) */}
            <MDBox
              sx={{
                width: { xs: "70%", md: "2px" }, // ancho completo en móviles, línea vertical en desktop
                height: { xs: "2px", md: "50px" }, // barra horizontal en móviles, vertical en desktop
                backgroundColor: "white !important",
                opacity: 0.7,
                my: { xs: 1, md: 0 },
                mx: { xs: 0, md: 2 },
              }}
            />

            {/* Imagen derecha */}
            <img src={logoGMF} style={{ height: "3rem" }}></img>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={6} ref={RefTerminos}>
          <MDBox textAlign="left" display="flex" alignItems="center" height="100%">
            <MDTypography variant="h4" color="text">
              Formato para candidatos a implante coclear
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>
      <Divider />

      <MDBox textAlign="center">
        <Button
          variant="contained"
          startIcon={<Icon>help</Icon>}
          color="primary"
          style={{ background: "#605CA9" }}
          onClick={() => {
            const nombreArchivo = "MANUAL DE USUARIO - ASPIRANTE ESCUCHAR SIN FRONTERAS v1.pdf";
            window.open(`/ayuda/${encodeURIComponent(nombreArchivo)}`, "_blank");
          }}
        >
          Presione este botón si necesita ayuda para llenar el formulario
        </Button>
      </MDBox>

      <Divider />

      <Grid container spacing={3}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="center">
            <Button
              variant="contained"
              onClick={() => {
                setModalAvisoPrivacidad(true);
              }}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              Ver aviso de privacidad
            </Button>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox display="flex" alignItems="center" paddingTop="0.8rem">
            <MDBox mt={0.5}>
              <SwitchR
                onChange={() => {
                  setcheckavisoprivacidad(!checkavisoprivacidad);
                }}
                checked={checkavisoprivacidad}
                height={20}
                width={50}
                handleDiameter={18}
                onColor="#605CA9"
              />
            </MDBox>
            <MDBox ml={0.5}>
              <MDTypography variant="button" fontWeight="regular" color="text">
                He leído y acepto el aviso de privacidad
              </MDTypography>
            </MDBox>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <MDBox display="flex" alignItems="center">
            <MDBox mt={0.5}>
              <SwitchR
                onChange={() => {
                  setcheckacuerdo(!checkacuerdo);
                }}
                checked={checkacuerdo}
                height={20}
                width={50}
                handleDiameter={18}
                onColor="#605CA9"
              />
            </MDBox>
            <MDBox ml={0.5}>
              <MDTypography variant="button" fontWeight="regular" color="text">
                Estoy de acuerdo que la recepción de esta solicitud no constituye una obligación de
                ninguna especie entre el solicitante y Fundación Grupo México A.C. , al enviarla
                estamos aceptando que se realice la evaluación y el resultado de esta.
              </MDTypography>
            </MDBox>
          </MDBox>
        </Grid>
      </Grid>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        sx={{ background: "#1a2035 !important" }}
      >
        {steps.map((step, index) => (
          <Step key={step.label} ref={step.ref}>
            <StepLabel
              StepIconComponent={({ active, completed, className }) => {
                return (
                  <QontoStepIconRoot ownerState={{ active }} className={className}>
                    {completed ? (
                      <Check className="QontoStepIcon-completedIcon" color="primary" />
                    ) : (
                      <div className="QontoStepIcon-circle"></div>
                    )}
                  </QontoStepIconRoot>
                );
              }}
            >
              {step.label}
            </StepLabel>
            <StepContent
              sx={{ marginLeft: "6px", borderLeft: "0.125rem solid rgba(159, 201, 255,0.5)" }}
            >
              {step.component}

              <Divider />
            </StepContent>
          </Step>
        ))}
      </Stepper>

      <ModalContent
        title={"Proceso de registro"}
        maxWidth="lg"
        fullWidth={true}
        open={isLoadingCracion}
        fullScreen={false}
        handleClose={() => {
          if (Errores.length > 0) {
          // Caso con errores: cerrar modal y quitar loading
          dispatch(setIsloadingCreacion(false));
          } else if (!procesoExitoso) {
          // Caso: proceso aún en ejecución → no hacer nada, mantener el modal abierto
          return;
          } else {
          // Caso: éxito y proceso terminado → refrescar pantalla
          window.location.reload();
        }
        }}
        handleAcept={() => {}}
        textAccept=""
        textCancelar={Errores.length > 0 ? "Cerrar" : "Terminar proceso"}
      >
        <MDBox>
          {map(messageError, (item) => {
            return (
              <p>
                <MDTypography variant="button" color="text" fontWeight="regular">
                  {item.message}
                </MDTypography>
              </p>
            );
          })}
        </MDBox>
      </ModalContent>

      <ModalExito open={isLoadingExito} onClose={() => dispatch(setIsloadingExito(false))} />

      <ModalContent
        title={"Aviso de Privacidad"}
        maxWidth="lg"
        fullWidth={true}
        open={modalAvisoPrivacidad}
        fullScreen={false}
        handleClose={() => {
          setModalAvisoPrivacidad(false);
        }}
        handleAcept={() => {}}
        textAccept=""
        textCancelar={"Cerrar aviso de privacidad"}
      >
        <MDBox>
          <AvisoPrivacidad></AvisoPrivacidad>
        </MDBox>
      </ModalContent>
    </Box>
  );
}
